import { lazy } from 'react';

/**
 * The four document surfaces, loaded on demand.
 *
 * A meeting opens on the upload prompt, and a participant only ever sees one
 * of these — yet importing them statically put ALL of their libraries in the
 * entry graph, so Vite emitted a `modulepreload` for each before first paint:
 * Univer (1.16 MB), TipTap, PDF.js. Measured 2026-09-01: 7.42 MB of JS and CSS
 * fetched, parsed and executed before anything renders, against a documented
 * design target of ~85 KB.
 *
 * `manualChunks` in vite.config.ts names these chunks but cannot make them
 * lazy — a chunk is preloaded because something in the eager graph imports it,
 * and only an `import()` at the call site breaks that edge. Splitting the
 * chunk and splitting the load are two different things, which is how the
 * regression went unnoticed: the build log showed the separate chunks all
 * along.
 *
 * Keep every viewer reached through this module. A plain
 * `import { PdfViewer } from './PdfViewer.js'` anywhere in the eager tree puts
 * it, and everything it pulls, straight back into the first paint.
 */

export const PdfViewer = lazy(() =>
  import('./PdfViewer.js').then((m) => ({ default: m.PdfViewer })),
);

export const ImageViewer = lazy(() =>
  import('./ImageViewer.js').then((m) => ({ default: m.ImageViewer })),
);

export const DocxEditor = lazy(() =>
  import('./DocxEditor.js').then((m) => ({ default: m.DocxEditor })),
);

export const SpreadsheetEditor = lazy(() =>
  import('./SpreadsheetEditor.js').then((m) => ({ default: m.SpreadsheetEditor })),
);
